import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LeadFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const leadSourceOptions = [
    { value: 'all', label: 'Todas las fuentes' },
    { value: 'referral', label: 'Referido' },
    { value: 'website', label: 'Sitio web' },
    { value: 'social_media', label: 'Redes sociales' },
    { value: 'walk_in', label: 'Visita directa' },
    { value: 'phone', label: 'Llamada telefónica' },
    { value: 'event', label: 'Evento' }
  ];

  const interestLevelOptions = [
    { value: 'all', label: 'Todos los niveles' },
    { value: 'hot', label: 'Alto interés' },
    { value: 'warm', label: 'Interés medio' },
    { value: 'cold', label: 'Bajo interés' }
  ];

  const budgetRangeOptions = [
    { value: 'all', label: 'Todos los presupuestos' },
    { value: '0-200000', label: 'Hasta S/ 200,000' },
    { value: '200000-400000', label: 'S/ 200,000 - S/ 400,000' },
    { value: '400000-600000', label: 'S/ 400,000 - S/ 600,000' },
    { value: '600000-800000', label: 'S/ 600,000 - S/ 800,000' },
    { value: '800000+', label: 'Más de S/ 800,000' }
  ];

  const followUpStatusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'pending', label: 'Pendiente' },
    { value: 'scheduled', label: 'Programado' },
    { value: 'completed', label: 'Completado' },
    { value: 'overdue', label: 'Vencido' }
  ];

  const stageOptions = [
    { value: 'all', label: 'Todas las etapas' },
    { value: 'new', label: 'Nuevo' },
    { value: 'contacted', label: 'Contactado' },
    { value: 'qualified', label: 'Calificado' },
    { value: 'proposal', label: 'Propuesta' },
    { value: 'negotiation', label: 'Negociación' },
    { value: 'closed_won', label: 'Ganado' },
    { value: 'closed_lost', label: 'Perdido' }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border mb-4 md:mb-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center">
          <Icon name="Filter" size={20} className="mr-2 text-primary" />
          <h3 className="text-lg font-semibold text-foreground font-heading">
            Filtros Avanzados
          </h3>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Limpiar
        </Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <Input
          type="search"
          label="Buscar"
          placeholder="Nombre, teléfono, email..."
          value={filters?.search}
          onChange={(e) => onFilterChange('search', e?.target?.value)}
        />

        <Select
          label="Fuente de Lead"
          options={leadSourceOptions}
          value={filters?.source}
          onChange={(value) => onFilterChange('source', value)}
        />

        <Select
          label="Nivel de Interés"
          options={interestLevelOptions}
          value={filters?.interestLevel}
          onChange={(value) => onFilterChange('interestLevel', value)}
        />

        <Select
          label="Rango de Presupuesto"
          options={budgetRangeOptions}
          value={filters?.budgetRange}
          onChange={(value) => onFilterChange('budgetRange', value)}
        />

        <Select
          label="Estado de Seguimiento"
          options={followUpStatusOptions}
          value={filters?.followUpStatus}
          onChange={(value) => onFilterChange('followUpStatus', value)}
        />

        <Select
          label="Etapa del Pipeline"
          options={stageOptions}
          value={filters?.stage}
          onChange={(value) => onFilterChange('stage', value)}
        />
      </div>
    </div>
  );
};

export default LeadFilters;